module.exports = __webpack_public_path__ + "static/media/deleteUser.svg";